import {
  LinkCategory,
  LinkLabelCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import { MappingLabel } from 'src/containers/ProjectDiagram/types/data';
import { CreateMappingLabelOverrideOptions } from 'src/containers/ProjectDiagram/types/mapping';
import { getResourceKey } from 'src/containers/ProjectDiagram/utils/resource/createResource';

export type CreateMappingLabelOptions = {
  text: string;
  value: string;
} & CreateMappingLabelOverrideOptions;

export const getMappingLabelKey = ({
  fromId,
  value,
  toKey,
}: {
  fromId?: string;
  value: string;
  toKey?: string;
}) => `${LinkLabelCategory.MAPPING_LABEL}-${fromId}-${value}-${toKey}`;

export const getLabelKeyFromMappingKey = (linkKey: string) =>
  linkKey.replace(
    new RegExp(`^${LinkCategory.MAPPING}`),
    LinkLabelCategory.MAPPING_LABEL
  );

export const createMappingLabel = ({
  fromId,
  value,
  text,
  toKey,
  keyOverride,
}: CreateMappingLabelOptions): MappingLabel => ({
  key: keyOverride || getMappingLabelKey({ fromId, value, toKey }),
  from: getResourceKey(fromId),
  value,
  to: toKey,
  text,
  category: LinkLabelCategory.MAPPING_LABEL,
});
